import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const MOBILE_BOTTOM_NAV_PREFIXES = ['/tree/', '/family/', '/person/'];

export function useBridgeAssistantContext() {
  const location = useLocation();

  return useMemo(() => {
    const { pathname, search } = location;
    const sp = new URLSearchParams(search || '');

    let page = 'app';
    let treeBase = null;
    let treeId = null;
    let personId = null;
    let personHref = null;
    let tab = sp.get('tab') || null;

    if (pathname === '/dashboard' || pathname === '/family-spaces') {
      page = 'dashboard';
    } else if (pathname.startsWith('/tree/')) {
      page = 'tree';
      treeId = pathname.split('/')[2] || null;
      treeBase = treeId ? `/tree/${treeId}` : null;
    } else if (pathname.startsWith('/family/')) {
      page = 'tree';
      const slug = pathname.split('/')[2] || null;
      treeBase = slug ? `/family/${slug}` : null;
    } else if (pathname.startsWith('/person/')) {
      page = 'person';
      personId = pathname.split('/')[2] || null;
      personHref = personId ? `/person/${personId}` : null;
    } else if (pathname.startsWith('/storybook')) {
      page = 'storybook';
    } else if (pathname.startsWith('/story-studio')) {
      page = 'story-studio';
    } else if (pathname.startsWith('/vault')) {
      page = 'vault';
    } else if (pathname.startsWith('/memorials/manage')) {
      page = 'memorial-manage';
      const ref = pathname.split('/')[3];
      if (ref && !personHref) {
        personHref = `/person/${ref}`;
        personId = ref;
      }
    } else if (pathname.startsWith('/memorials')) {
      page = 'memorial';
    } else if (pathname.startsWith('/reminders')) {
      page = 'reminders';
    } else if (pathname.startsWith('/settings')) {
      page = 'settings';
    } else if (pathname.startsWith('/dna')) {
      page = 'dna';
    }

    const hasMobileBottomNav = MOBILE_BOTTOM_NAV_PREFIXES.some((prefix) => pathname.startsWith(prefix));

    return {
      page,
      pathname,
      search,
      tab,
      treeBase,
      treeId,
      personId,
      personHref,
      hasMobileBottomNav,
    };
  }, [location]);
}

export default useBridgeAssistantContext;
